import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { NEW_DATA_ENTRY, NEW_QA_REVIEW } from '../../../../../routeNames.js';

const CustomSweetAlert = ({
  alert,
  hideAlert,
  // Additional props for business logic
  jobData,
  notification,
  setingPayer,
  setPayerPullPath,
  handleNavigateDashBoard,
  handlePermissionJob,
  loadNextJob,
  
  // Constants
}) => {
  const currentPath = window.location.pathname;

  if (!alert.isOpen) return null;

  // Get alert configuration based on type
  const getAlertConfig = () => {
    switch (alert.type) {
      case 'payerExcluded':
        return {
          type: 'error',
          title: 'Payer is Excluded',
          confirmBtnText: 'CONTINUE',
          showCancel: true,
          cancelBtnCssClass: 'exce-payer-sweetalert',
          cancelBtnBsStyle: 'default',
          onConfirm: () => {
            setingPayer();
            hideAlert();
            if(alert?.onConfirm){alert?.onConfirm(true)}
        },
        onCancel: () => {
            hideAlert();
            setPayerPullPath(null);
            if(alert?.onCancel){alert?.onCancel()}
          }
        };

      case 'general':
        return {
          type: 'error',
          title: alert.title??"",
          confirmBtnText: 'Ok!',
          customContent: <span className='fw-bolder'>{alert.message}</span>,
          onConfirm: () => {
            hideAlert();
            if(alert?.onConfirm){alert?.onConfirm()}
        },
        };

      case 'notification':
        const shouldShowNotification =  
          notification.title && 
          notification?.job == jobData?.file_info?.job_unique_id && 
          (currentPath == NEW_DATA_ENTRY || currentPath == NEW_QA_REVIEW);
          
        if (!shouldShowNotification) return null;
        
        return {
          type: 'warning',
          title: notification.title,
          confirmBtnText: 'Ok!',
          focusConfirmBt: true,
          onConfirm: handleNavigateDashBoard
        };

      case 'comment':
        const shouldShowComment = alert.data?.facilitySwal?.isSwal !== true;
        if (!shouldShowComment) return null;
        
        return {
          type: 'warning',
          confirmBtnText: 'Ok!',
          focusConfirmBt: true,
          onConfirm: hideAlert,
          customContent: (
            <div>
              {jobData?.is_large_batch_job && (
                <React.Fragment>
                  <span className='fw-bold'>
                    {currentPath === NEW_DATA_ENTRY 
                      ? `Large Batch File ${jobData?.is_last_sub_job ? "Last Job" : ""}` 
                      : 'Large Batch'}
                  </span>
                  <br />
                </React.Fragment>
              )}

              {jobData?.file_info?.comment && (
                <React.Fragment>
                  <div className='' style={{ width: '100%' }}>
                    {jobData?.file_info?.comment ? (
                      <span className='pt-5 text-uppercase'>
                        <div className='d-flex flex-column'>
                          {jobData?.file_info?.comment.split(',\n\r').map((line, index) => (
                            <React.Fragment key={index}>
                              <div>{line}</div>
                            </React.Fragment>
                          ))}
                        </div>
                      </span>
                    ) : (
                      <span className='pt-5 text-uppercase'>
                        {jobData?.file_info?.comment}
                      </span>
                    )}
                  </div>
                </React.Fragment>
              )}
            </div>
          )
        };

      case 'error':
        return {
          type: 'danger',
          confirmBtnText: alert.data?.is_errorJob ? 'RELOAD DATA' : 'Ok!',
          onConfirm: handlePermissionJob,
          customContent: <span className='fw-bolder'>{alert.message}</span>
        };

      case 'error837':
        return {
          type: 'danger',
          confirmBtnText: 'Ok!',
          onConfirm: hideAlert,
          customContent: <span className='fw-bolder'>{alert.message}</span>
        };

      case 'facility':
        return {
          type: 'warning',
          title: 'Client or Facility Changed',
          confirmButtonColor: '#6ba2b6',
          confirmBtnText: 'Ok!',
          onConfirm: hideAlert
        };

      case 'automation':
        const shouldShowAutomation = currentPath === NEW_DATA_ENTRY;
        if (!shouldShowAutomation) return null;
        
        return {
          type: 'warning',
          title: jobData?.grid_data?.automation_status,
          confirmBtnText: 'Ok!',
          onConfirm: hideAlert
        };
        case 'noPermission':
        return {
          type: 'error',
          title: alert.title??"",
          confirmBtnText: 'Ok!',
          customContent: <span className='fw-bolder'>{alert.message}</span>,
          onConfirm: () => {
            hideAlert();
            loadNextJob()

            if(alert?.onConfirm){alert?.onConfirm()}
        },
        };


      default:
        return null;
    }
  };

  const config = getAlertConfig();
  if (!config) return null;

  const alertProps = {
    [config.type]: true,
    confirmBtnText: config.confirmBtnText,
    confirmBtnCssClass: 'custom-confirm-button-class',
    title: config.title,
    onConfirm: config.onConfirm,
    ...(config.onCancel && { onCancel: config.onCancel }),
    ...(config.showCancel && { showCancel: config.showCancel }),
    ...(config.cancelBtnCssClass && { cancelBtnCssClass: config.cancelBtnCssClass }),
    ...(config.cancelBtnBsStyle && { cancelBtnBsStyle: config.cancelBtnBsStyle }),
    ...(config.focusConfirmBt && { focusConfirmBt: config.focusConfirmBt })
  };

  return (
    <SweetAlert {...alertProps}>
      {config.customContent}
    </SweetAlert>
  );
};

export default CustomSweetAlert;